import { SosInformationComponent } from "./directives/sos-information/sos-information.component";
import { SosTakeActionComponent } from "./directives/sos-take-action/sos-take-action.component";
import { SosListComponent } from "./sos-list/sos-list.component";
import { SosPanelComponent } from "./sos-panel.component";

export const SosPanelDeclaration = [
    SosPanelComponent,
    SosListComponent,

    /* directives */
    SosInformationComponent,
    SosTakeActionComponent
];
